module.exports = __webpack_public_path__ + "img/icon-arrow.69950c2d.svg";